import $ from 'cash-dom';

$(function () {
	$('.tabs-holder .tabs .tab-link').on('click', function (e) {
		e.preventDefault();

		const $currentTabHeader = $(this);
		const containerClass = $currentTabHeader.data('container-class');

		const $tabsHolder = $currentTabHeader.closest('.tabs-holder');
		const $tabsContent = containerClass
			? $tabsHolder.closest('.' + containerClass).find('.tabs-content')
			: $tabsHolder.find('.tabs-content');

		$tabsHolder.find('.tab-link').removeClass('active');
		$tabsContent.find('.tab-content').removeClass('active');

		$currentTabHeader.addClass('active');
		const tabId = $currentTabHeader.data('target');

		$tabsContent.find('.tab-content#' + tabId).addClass('active');

		$tabsContent.closest('.tabs-holder').attr('data-active-tab', tabId);
	});
});
